export const getFormattedPath = (path) => {
  if (!path || typeof path !== 'string') return 'Labeling';

  const normalizedPath = path.toLowerCase();

  // Handle special cases
  if (
    normalizedPath.includes('qaspecification.contacts.primaryqccontact') ||
    normalizedPath.includes('qaspecification.contacts.primaryqacontact')
  ) {
    return 'Contacts Primary QA Contact';
  }

  if (normalizedPath.includes('qaspecification.contacts._24hourcontact')) {
    return 'Contacts 24 Hour Contact';
  }

  // Default formatting logic
  const parts = path.split('.');
  const middleParts = parts.slice(1, -1);
  const formatted = middleParts.map((part) => {
    const withSpaces = String(part).replace(/([A-Z])/g, ' $1');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
  });
  return formatted.join(' ');
};

export const getFormattedFieldName = (fieldName) => {
  if (!fieldName || typeof fieldName !== 'string') return '';

  // Mapping for special cases
  const fieldNameOverrides = {
    kosherYN: 'Kosher',
    organicYN: 'Organic',
    halalYN: 'Halal',
    nonGMOYN: 'Non-GMO',
    isoyn: 'ISO',
    brcyn: 'BRC',
    ifsyn: 'IFS',
    claim1: 'Claim 1',
    claim2: 'Claim 2',
    claim3: 'Claim 3',
    claim4: 'Claim 4',
    claim5: 'Claim 5',
    cookingInstructions: 'Cooking Instructions/ Directions',
    biodegradable: 'Biodegradable - Packaging',
    usdaGrading: 'USDA / AAFC Grading',
    identificationCode: 'Identification Code(1-7)',
    productionSystem: 'Production System - Applicable to Aquaculture',
    totalMeatProteinMinPercentage:
      'Total Meat Protein Equivalent Min Percentage',
    addedRindsMaxPercentage:
      'Added rinds maximum percentage: added rind shall not exceed value',
    fatMaxPercentage:
      'Fat maximum percentage: total fat percentage on nutritional analyses',
    hasFoodGradePlasticsCertifier: 'Contains Food Grade Plastics',
    tailOffOrOn: 'Tail off or On (Shrimp)',
    peeledDeveined: 'Peeled, Deveined (Shrimp)',
    addedGelatineMaxPercentage: 'Added gelatin maximum percentage',
    recycledMaterial: 'Made With Recycled Material',
    bilingual: 'Additional Languages on Label',
    warningStatement: 'Warning / Caution Statement',
    bioengineeredStatement: 'Bioengineered Ingredients Statement',
    ecoFisheryYN: 'Eco Fishery Claim',
    waterQualityAssociationCertified: 'Water Quality Association',
    adaSealofAcceptanceClaim: 'ADA Seal of Acceptance',
    fairTradeYN: 'Fair Trade',
    npayn: 'NPA',
    beeBetterClaim: 'Bee Friendly',
    forLifeYN: 'For Life',
    pacayn: 'PACA Compliant',
    wholeGrainYN: 'Whole Grain',
    bioBasedYN: 'Bio-Based',
    glyphosateResidueFreeClaim: 'Glyphosate Residue Free',
    paleoYN: 'Paleo',
    gmpyn: 'GMP Claim',
    pasayn: 'PASA Compliant',
    productIsBiodegradable: 'Biodegradable - Product',
    grassFedYN: 'Grass Fed',
    plantBasedDerivedClaim: 'Plant Based / Derived',
    bioDynamicYN: 'Bio - Dynamic',
    heartHealthyYN: 'Heart Healthy',
    rainForestAllianceYN: 'Rain Forest Alliance',
    bioengineeredYN: 'Bioengineered',
    healthyYN: 'Healthy Claim',
    realCertifiedClaim: 'REAL Certified',
    containsBPA: 'BPA - Contains',
    realSealYN: 'Real Dairy Seal',
    highPressureCertifiedClaim: 'High Pressure Certified',
    veganYN: 'Vegan',
    ingredientsChina: 'Ingredients Sourced from China',
    vegetarianYN: 'Vegetarian',
    carbonFootprintYN: 'Carbon Footprint',
    italCertifiedSealClaim: 'ITAL Certified Seal',
    viticultureYN: 'Vitaculture',
    cradleToCradleYN: 'Cradle To Cradle',
    italConsciousSealClaim: 'ITAL Conscious Seal',
    crueltyFreeYN: 'Cruelty Free',
    italSacramentSealClaim: 'ITAL Sacrament Seal',
    diabeticFriendlyYN: 'Diabetic Friendly',
    ketoYN: 'Keto / Ketogenic',
    lowGlycemicYN: 'Low Glycemic',
    organicIngredientsMadeWith: 'Made with Organic Ingredients',
    _1_4_Dioxane: '1.4-dioxane',
    _1_Bromopropane: '1-Bromopropane',
    hbcd: 'Cyclic Aliphatic Bromides Cluster of flame retardants',
    d4: 'Octamethylcyclotetrasiloxane (D4)',
    leadCompounds: 'Lead and Lead Compounds',
    cadmiumCompounds: 'Cadmium and Cadmium Compounds',
  };

  // Return override if available
  if (fieldNameOverrides[fieldName]) {
    return fieldNameOverrides[fieldName];
  }

  const formatted = String(fieldName).replace(/([A-Z])/g, ' $1');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
